export const ERR_CANNOT_CONNECT = 1;
export const ERR_INVALID_AUTH = 401;
export const ERR_CONNECTION_LOST = 3;
export const ERR_TAUI_HOST_REQUIRED = 4;
export const ERR_INVALID_HTTPS_TO_HTTP = 5;
